import { toLitiumMediaUrlKey } from "@distancify/drapejs-litium/lib/keys";
import { inject } from "vue";

export default function () {
  return {
    toLitiumMediaUrl: inject(toLitiumMediaUrlKey, () => ''),
  };
}
